<script>
	import CreateCarForm from "./CreateCarForm.svelte";
	export let vehicleId;

</script>
<CreateCarForm isEdit={vehicleId} />